function _replaceWithFallback(url) {
    if (url.includes('fallback')) return url;

    // replace something like 'svc-0-search-app' with 'svc-0-fallback-search-app'
    return url.replace(/svc-(\d+)-/,'svc-$1-fallback-');
}

async function fetchDataWithRetry(primaryUrl, backupUrl, maxRetries = 10) {
  let retries = 0;
  let currentUrl = primaryUrl;

  async function fetchData() {
    try {
      const response = await fetch(currentUrl);

      if (response.ok) {
        // return response.json();
        return response;
      } else {
        throw new Error(`Failed to fetch data: ${response.status}`);
      }
    } catch (error) {
      console.error(error);

      retries++;

      if (retries <= maxRetries) {
        console.log(`Retrying (${retries}/${maxRetries})...`);
        // You can add a delay between retries if needed
        // For example: await new Promise(resolve => setTimeout(resolve, 1000));
        return fetchData();
      } else if (currentUrl === primaryUrl) {
        console.error(`Max retries (${maxRetries}) reached for primary URL. Switching to backup server.`);
        currentUrl = backupUrl;
        retries = 0; // Reset retries when switching to backup server
        console.log('Retrying with backup server...');
        return fetchData();
      } else {
        console.error(`Max retries (${maxRetries}) reached for backup URL.`);
        throw new Error('Max retries reached for both primary and backup URLs.');
      }
    }
  }

  return fetchData();
}

function sortByKey(array, key) {  
    return array.sort(function(a, b) {
        var x = a[key]; var y = b[key];
        return x.localeCompare(y, undefined, {sensitivity: 'base'}) 
    });
}

String.prototype.replaceAllUSF = function(search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

function IsJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

var reloadSR = () => {
    if (window.usf && window.usf.query && window.usf.query.update) {
        var oldQ = usf.query.get('q', '')
        window.usf.query.update({
            q: -6969696969
        }, [], {
            force: true
        });

        window.usf.query.update({
            q: oldQ
        }, [], {
            force: true
        });
        usf.search.refresh()
    }
}

const template = `
<div class="container mar-bottom-20">
  <div class="section-filter-v2">
      <div class="azirspares-heading">
        <h3><span>FIND MY FIT</span></h3>
          <button style="margin-left:20px;" v-if="submited" @click="clearFilters">Clear Filters</button>
      </div>
  </div>

  <div class=" container--flush mar-top-30 mar-bottom-30 px-sm-4 filter-group engojs-filter-v2-wrapper" style="position:relative">
  	<loading :active.sync="loadingShow" :is-full-page="false"></loading>
     <div class="card">
        <div class="card__section card__section--tight">
           <form class="ymm-form" novalidate>
              <div class="product-list f-list" style="overflow: visible;" v-for="(f,index) in ymmFiltersData" :key="f['key']">
                 <div class="col col-md-3 col-lg-2 f-item">
                    <Multiselect 
                        v-model="f['selectedValues']" 
                        @clear="changedFacets(index)" 
                        @select="changedFacets(index)" 
                        @deselect="changedFacets(index)"  
                         :options="f['values']" 
                         :placeholder="f['placeholder']" 
                         v-bind="multiSelectProps"  
                         :disabled="ymmFilterSelectType === 1 && index>0 && ymmFiltersData[index-1] && ymmFiltersData[index-1]['selectedValues'] && ymmFiltersData[index-1]['selectedValues'].length == 0"
                    ></Multiselect>
                 </div>
              </div>
             
              <div class="product-list f-list" style="overflow: visible;" >
                 <div class="col col-md-2 f-item">
                    <button class="button button--primary save_data" type="button" @click="submit" style="">Search</button>
                 </div>
              </div>
           </form>
           <!--<div id="my_vehicle" class="text-center " v-else>
              <span>My Filters : <span id="current_vehice" v-html="currentFacetsString"></span> </span> 
              <button class="button button--ternary ml-2 change_vehicle" @click="submited = false" type="button" style="margin-right:10px;margin-left:10px;">Change Filters</button>
              <a href="/collections/all">
              <button class="button button--ternary ml-2 browse_parts" @click.prevent="browseItems" type="button" style="margin-right:10px;">Browse Items</button>
              </a>
              <button class="button button--primary ml-2 clear_vehice" @click.prevent="clearFilters" type="button" style="margin-right:10px;">Clear Filters</button>
           </div>-->
        </div>
     </div>
  </div>
</div>
`

const {
    createApp
} = Vue;

function isEmpty(obj) {
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            return false;
        }
    }
    return JSON.stringify(obj) === JSON.stringify({});
}

function copyObj(r) {
    return JSON.parse(JSON.stringify(r));
}

const app = createApp({
    data() {
        return {
            ymmFiltersData: JSON.parse(JSON.stringify(ymmFilters)),
            loadingShow: 1,
            multiSelectProps: {
                valueProp: "label",
                searchable: true,
                mode: "tags"
            },
            submited: false,
          ymmFilterSelectType : 1,
          showConfirmStep:1
        }
    },
    template: template,
    async created() {

        await this.init();
        var ymmCookieData = location.pathname == sessionStorage.getItem('usf_pathname') || location.pathname != '/search' ? '[]' : Cookies.get('ymm');
        let count = 0; 
        try {
            let ymmCookieJson = JSON.parse(ymmCookieData);
            for (let i = 0; i < ymmCookieJson.length; i++) {
                let cookieFacet = ymmCookieJson[i];
                for (let j = 0; j < this.ymmFiltersData.length; j++) {
                    let appFacet = this.ymmFiltersData[j];
                    if (cookieFacet['key'] == appFacet['key']) {
                        this.ymmFiltersData[j]['selectedValues'] = cookieFacet['selectedValues'];
                        count++;
                    }
                }
            }
            if (count > 0)
                this.submited = true;
        } catch (e) {
            console.log("error : ", e)

            Cookies.set('ymm', '[]');
            this.submited = false;
        }
        // await this.init();
        sessionStorage.setItem('usf_pathname', location.pathname)
    },



    methods: {
        clearFilters() {
            for (let i = 0; i < this.ymmFiltersData.length; i++) {
                this.ymmFiltersData[i]['selectedValues'] = [];
            }
            Cookies.set('ymm', '[]');
            this.submited = false;
          	this.changedFacets(0);
//           	reloadSR();
          	this.browseItems();

        },
        browseItems() {
            window.location.href = this.submitUrl
//           window.location.href = '/search'
        },
        submit(e) {
            e.preventDefault();
          
            if (!this.currentFacets){
              Toastify({
                  text: "You need to select at least one field",
                  duration: 3000,
                  newWindow: true,
                  close: true,
                  gravity: "top", // `top` or `bottom`
                  position: "right", // `left`, `center` or `right`
                  stopOnFocus: true, // Prevents dismissing of toast on hover
                  style: {
                      background: "linear-gradient(to right, #ff5f6d, #ffc371)"
                  }
              }).showToast();
              return;
            }
          
          
            let copiedYmmFilterData = JSON.parse(JSON.stringify(this.ymmFiltersData));
            for (let i = 0; i < copiedYmmFilterData.length; i++) {
                let f = copiedYmmFilterData[i];
                f['values'] = [];
            }
            let text = JSON.stringify(copiedYmmFilterData)
            console.log("text : ", text);
            Cookies.set('ymm', text);
            this.submited = true;
          this.browseItems();
            return false;
        },
        async changedFacets(index) {
            this.loadingShow = true;
            let selectedFilter = this.ymmFiltersData[index];

          	let startIndex = (this.ymmFilterSelectType ===1 ? index + 1 :0);

            for (let j = startIndex; j < this.ymmFiltersData.length; j++) {
                this.ymmFiltersData[j]['values'] = [];
            }
			await new Promise(resolve => setTimeout(resolve, 100));

            fetchDataWithRetry(this.getAPIEndpoint,this.getAPIEndpointFallback)
              .then(response => response.json())
              .then((data) => {
                    let ymmFiltersDataCloned = copyObj(this.ymmFiltersData);
                    if (data.data && data.data.facets) {
                        var facetsResponse = data.data.facets;
                      for (let j = startIndex; j < ymmFiltersDataCloned.length; j++) {
                            let ymmFilterDataLocal = ymmFiltersDataCloned[j];
                            for (let i = 0; i < facetsResponse.length; i++) {
                                let facetResponse = facetsResponse[i];
                                if (facetResponse['facetName'] == ymmFilterDataLocal['key']) {
                                  	var newF = JSON.parse(JSON.stringify(facetResponse['labels'])) 
                                    newF = sortByKey(newF, "label");
                                    ymmFiltersDataCloned[j]['values'] = newF
                                }
                            }
                        }
                    }
                    var datesMM = ymmFiltersDataCloned.find(m => m.key == 'metafield:global.vehicle_year');
                    datesMM.values.sort(function(a, b){
                        var aa = Date.parse(a.label.split(' - ')[0].split('/').join('/1/'));
                        var bb = Date.parse(b.label.split(' - ')[0].split('/').join('/1/'));
                        if (!aa) return -1;
                        if (!bb) return 1;
    
                        if (aa < bb) return 1;
                        if (aa > bb) return -1;
                        return 0;
                    });         
              
                    this.ymmFiltersData = ymmFiltersDataCloned;
                })
                .then(() => { 
                    this.loadingShow = false;
                })
                .catch((e) => {
                    console.error(e)
                });
            return true;
        },

        async init() {
            var vm = this;
            this.loadingShow = true;
            let ymmFiltersDataCloned = copyObj(this.ymmFiltersData);

            await fetchDataWithRetry(this.getAPIEndpoint,this.getAPIEndpointFallback).then(response => response.json()).then((data) => {
                if (data.data && data.data.facets) {
                    var facetsResponse = data.data.facets;
                    for (let i = 0; i < facetsResponse.length; i++) {
                        let facetResponse = facetsResponse[i];
                        for (let j = 0; j < ymmFiltersDataCloned.length; j++) {
                            let ymmFilterDataLocal = ymmFiltersDataCloned[j];
                            if (facetResponse['facetName'] == ymmFilterDataLocal['key']) {
                              	var newF = JSON.parse(JSON.stringify(facetResponse['labels']));
                                    newF = sortByKey(newF, "label");
                             
                                ymmFiltersDataCloned[j]['values'] = newF;
                                ymmFiltersDataCloned[j]['id'] = facetResponse['id']
                            }
                        }
                    }
                }
                var datesMM = ymmFiltersDataCloned.find(m => m.key == 'metafield:global.vehicle_year');
                datesMM.values.sort(function(a, b){
                    var aa = Date.parse(a.label.split(' - ')[0].split('/').join('/1/'));
                    var bb = Date.parse(b.label.split(' - ')[0].split('/').join('/1/'));
                    if (!aa) return -1;
                    if (!bb) return 1;

                    if (aa < bb) return 1;
                    if (aa > bb) return -1;
                    return 0;
                });
              
                this.ymmFiltersData = ymmFiltersDataCloned;
            }).then(() => {
                this.loadingShow = false;
            });
        },
    },

    computed: {
        submitUrl() {
            var p = {}

            for (let i = 0; i < this.ymmFiltersData.length; i++) {
                let filter = this.ymmFiltersData[i];
                if (filter['selectedValues'].length) {
                    let id = 'uff_' + parseInt(filter['id']).toString(36) + '_' + filter['key'];
                    let values = filter['selectedValues'].map(String);
                    p[id] = values.join('_usf_')
                }
            }

            var params = new URLSearchParams(p);
            var s = params.toString()
            s = s.replaceAllUSF('%7C', '_usf_')
            var apiUrl;
            apiUrl = '/search?' + s;
            return apiUrl;
        },


        currentFacets() {
            var f = {}

            for (let i = 0; i < this.ymmFiltersData.length; i++) {
                let filter = this.ymmFiltersData[i];
                if (filter['selectedValues'].length) {
//                     let id = '_usf_' + filter['key'];
                   	let id = filter['id'];
                    f[id] = [filter['key'], filter['selectedValues']]
                }
            }
            if (!isEmpty(f))
                return f
            return false;
        },
        currentFacetsString() {
            if (!this.currentFacets) return "";
            else {
                let arr = [];
                for (let i = 0; i < this.ymmFiltersData.length; i++) {
                    let filter = this.ymmFiltersData[i];
                    if (filter['selectedValues'].length) {
                        arr.push(filter['selectedValues'].join(','));
                    }
                }

                return arr.join(' | ')
            }
        },
        getAPIEndpoint() {
            var p = {
                q: '',
                apiKey: usf.settings.siteId,
                skip: 0,
                take: 1
            }
            let currentFacets = this.currentFacets;
            if (currentFacets) {
                p['facetFilters'] = JSON.stringify(currentFacets)
            }
            var params = new URLSearchParams(p)
            var apiUrl = usf.settings.searchSvcUrl + 'search?' + params;
            // var apiUrl = 'https://svc-5-usf.hotyon.com/' + 'search?' + params;
            return apiUrl;
        },

      getAPIEndpointFallback(){
        return _replaceWithFallback(this.getAPIEndpoint)
      }
    }
});


app.use(VueLoading.Plugin);
app.component('loading', VueLoading.Component)
app.component('Multiselect', VueformMultiselect)

window.addEventListener('load', function() {
	app.mount('#ymm_app')
    document.querySelector('.azirspares-heading').addEventListener('click', function() {
      document.body.classList.toggle('show-ymm')
    })
})